import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

import WaldoSpeechBubble from '../../../../../../../components/global/WaldoSpeechBubble';
import { getAccountAuthOptions } from '../../helpers';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      email_addresses: PropTypes.arrayOf(PropTypes.string),
      phone_number: PropTypes.string,
    }),
  ).isRequired,
  firstName: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

const AccountAuthOptionStep = ({ accounts, firstName, onSelect }) => {
  const options = useMemo(() => getAccountAuthOptions(accounts), [accounts]);

  return (
    <Fragment>
      <WaldoSpeechBubble className="w-100-i mx-0 mb-2 text-sm" position="right">
        We found multiple contact methods associated with{' '}
        {firstName ? `${firstName}'s` : 'this'} account. For security purposes,
        please select where you&apos;d like a PIN code sent.
      </WaldoSpeechBubble>
      <div className="account-auth-option-step">
        {options.map(option => (
          <Button
            btnStyle="reset"
            key={option.key}
            type="button"
            className="account-auth-option-tile"
            onClick={() =>
              onSelect(option.account, option.method, option.emailAddress)
            }
          >
            <span className="account-auth-option-value">{option.value}</span>
            <span className="account-auth-option-badges">
              {option.preferred && (
                <span className="badge badge-success ml-2">Preferred</span>
              )}
              <span className="badge badge-primary text-uppercase ml-2">
                {option.label}
              </span>
            </span>
          </Button>
        ))}
      </div>
    </Fragment>
  );
};

AccountAuthOptionStep.propTypes = propTypes;

export default AccountAuthOptionStep;
